<script>
  import GallerySlider from "./GallerySlider.svelte";
  import Image from "../Image.svelte";
  import Headlines from "./Headlines.svelte";
  import Text from "$lib/Text.svelte";

  export let block;
  let active = -1;

  $: slides = block.fields.map(({ employee }) => ({
    headline: employee.name,
    subline: employee.position,
    image: employee.detail_image || employee.image,
    text: employee.detail_text || employee.text,
  }));
</script>

<div class="py-16 bg-follow">
  <div class="max-w-content mx-auto overflow-hidden">
    {#if block.primary.tiles}
      <div class="flex flex-wrap -my-4 mx-4 lg:-mx-4">
        {#each block.fields as { employee }, index}
          <div
            on:click={() => (active = index)}
            class="p-4 w-full sm:w-1/2 lg:w-1/3 block cursor-pointer"
          >
            <div class="relative group overflow-hidden rounded-lg">
              <Image
                image={employee.image}
                class="transition duration-300 transform group-hover:scale-110 grayscale group-hover:grayscale-0"
              />
              <div
                class="absolute inset-0 text-white bg-black p-8 flex items-end opacity-0 transition duration-300 group-hover:opacity-100 bg-opacity-20"
              >
                <Headlines
                  headlines={{
                    headline: {
                      ...employee.name[0],
                      type: "heading3",
                    },
                    subline: {
                      ...employee.position[0],
                      type: "heading4",
                    },
                  }}
                  white={true}
                />
              </div>
            </div>
          </div>
        {/each}
      </div>
      <GallerySlider bind:active {slides} />
    {:else}
      <div class="flex flex-col -my-8 xl:-m-8">
        {#each block.fields as { employee }, index}
          <div class="flex flex-wrap w-full lg:w-3/4">
            <div class="p-8 w-full md:w-1/2 group">
              <Image
                image={employee.image}
                class="rounded-lg grayscale group-hover:grayscale-0 transition duration-300"
              />
            </div>
            <div class="p-8 lg:p-12 w-full md:w-1/2">
              <div class="mb-6">
                <Headlines
                  headlines={{
                    headline: {
                      ...employee.name[0],
                      type: "heading3",
                    },
                    subline: {
                      ...employee.position[0],
                      type: "heading4",
                    },
                  }}
                />
              </div>
              <Text text={employee.text} />
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>
